import { SelectProps } from '@radix-ui/react-select';

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/Select';
import useGetAuditActions from '@/hooks/useGetAuditActions';

interface ActionSelectProps extends SelectProps {
  additionalOptions?: {
    value: string;
    label: string;
  }[];
}

export default function ActionSelect({
  additionalOptions,
  ...props
}: ActionSelectProps) {
  const { auditActions } = useGetAuditActions();

  return (
    <Select {...props}>
      <SelectTrigger>
        <SelectValue placeholder="Select action" />
      </SelectTrigger>
      <SelectContent>
        {additionalOptions &&
          additionalOptions.map((opt) => (
            <SelectItem key={opt.value} value={opt.value}>
              {opt.label}
            </SelectItem>
          ))}

        {auditActions.map((action) => (
          <SelectItem key={action} value={action}>
            {action}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
